import { Outlet } from "react-router-dom";
import styled from "styled-components";

const Lesson = () => {
    return (
        <Container>
            <Outlet />
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    min-width: 0;
    width: 100%;
`;

export default Lesson;
